export default "__VITE_ASSET__ad76f77a__"